function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "redoA",
  d: "M0 0h34v24H0z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 8)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "redoB",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#redoA"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.262 9.331C20.935.18 8.932-.428 1.308 7.643V2.968H0v6.537c0 .45.293.817.654.817h5.232V8.688H2.35c7.125-7.322 18.2-6.683 24.987 1.8 7.14 8.92 7.14 23.437 0 32.357L28.262 44c7.65-9.557 7.65-25.111 0-34.669z",
  fill: "#000",
  mask: "url(#redoB)",
  transform: "matrix(-1 0 0 1 34 0)"
})));